export default function HalfRow(props) {
    const { children } = props;
    return <div className="col-span-12 sm:col-span-12">{children}</div>;
}
